import React, { useEffect, useContext } from 'react';
import { Route, withRouter, Switch, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FourOhFourError, StaticContext } from '@sm/webassets';
import { MetricsTracker } from '@sm/metrics';

import { HomePageV2, DetailsV2Page, MyAppsV2Page } from './pages';

const AppsDirectoryRouter = ({ history }) => {
  const {
    user,
    environment: { countryCode: country },
    'client-config': { loggingAPIPath, amplitudeToken },
  } = useContext(StaticContext);

  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, [history]);

  useEffect(() => {
    MetricsTracker.initialize({
      user: { id: user.id, isAuthenticated: user.isAuthenticated },
      loggingAPIPath,
      country,
      pageId: 'AppDirectory',
      amplitudeToken,
    });
  }, [user, country, loggingAPIPath, amplitudeToken]);

  // Hide usabilla for all pages - each individual page will set usabilla configs and show if enabled
  // Note the load of usabilla hides the button so this code is included if usabilla has already been loaded
  if (typeof window !== 'undefined' && window && window.usabilla_live) {
    window.usabilla_live('virtualPageView');
    window.usabilla_live('hide');
  }

  return (
    <Switch>
      <Route path="/apps/:appId/preview" render={props => <DetailsV2Page {...props} preview />} />
      <Route path="/apps/:appId/details" component={DetailsV2Page} exact />
      <Route path="/apps/my-apps" component={MyAppsV2Page} exact />
      <Route path="/apps/recently-added" exact>
        <Redirect to="/apps?from_v1=true" />
      </Route>
      <Route path="/apps/most-popular" exact>
        <Redirect to="/apps?from_v1=true" />
      </Route>
      <Route path="/apps/featured-apps" exact>
        <Redirect to="/apps?from_v1=true" />
      </Route>
      <Route path="/apps/search" exact>
        <Redirect to="/apps?from_v1=true" />
      </Route>
      <Route path="/apps/categories/:categoryKey" exact>
        <Redirect to="/apps?from_v1=true" />
      </Route>

      <Route path="/apps" component={HomePageV2} exact />

      <Route component={FourOhFourError} />
    </Switch>
  );
};

AppsDirectoryRouter.propTypes = {
  history: PropTypes.shape({
    listen: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(AppsDirectoryRouter);
